const HOST = process.env.REACT_APP_API_HOST;

if (!HOST) {
  console.error('REACT_APP_API_HOST environment variable is not set');
}

const PROTOCOL = window.location.protocol; // http: yoki https:

// Final API URL
const API = HOST ? `${PROTOCOL}//${HOST}/api` : '';

// Backward compatibility exports
const MAIN_URL = API;
const FILE_URL = HOST ? `${PROTOCOL}//${HOST}` : '';

export { MAIN_URL, FILE_URL };
export default API;
